var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mojs-burst',{attrs:{"id":"app","options":_vm.burstOptions}},[_c('img',{staticClass:"logo",attrs:{"alt":"Vue logo","src":require("./assets/logo.png")}}),_c('div',{staticClass:"container"},[_c('Demos')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }